import React from 'react';
import { Dialog as MuiDialog, DialogTitle as MuiDialogTitle, DialogContent as MuiDialogContent, DialogContentText as MuiDialogContentText, DialogActions as MuiDialogActions, Button } from 'components/ui';
import styled from "styled-components";
import colors from 'styles/colors';

const Dialog = styled(MuiDialog)`
  & .MuiDialog-paper {
    width: 1200px;
    max-width: none;
    border-radius: 24px;

    @media (min-width: 1441px) {
      margin-left: 300px;
    }
  }
`;

const DialogTitle = styled(MuiDialogTitle)`
  color: ${colors.brightGray[700]};
  font-family: Poppins !important;
  font-size: 32px !important;
  font-style: normal;
  font-weight: 400 !important; 
  line-height: 123.5%;
  letter-spacing: 0.25px;
`;

const DialogContent = styled(MuiDialogContent)`
  width: -webkit-fill-available;
`;

const DialogElements = styled.div`
  display: flex;
  padding: 32px 0px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const DialogContentText = styled(MuiDialogContentText)`
  color: ${colors.brightGray[700]} !important;
  font-family: "Source Sans Pro";
  font-size: 18px;
  font-style: normal;
  font-weight: 400 !important;
  line-height: 150%;
  letter-spacing: 0.25px !important;
`;

const DialogBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 52px;
  align-self: stretch;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const CardsDiv = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 30px;
  align-self: stretch;
  flex-wrap: wrap;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
  }
`;

const Cards = styled.div`
  display: flex;
  height: 350px;
  width: 356px;
  padding: 48px 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 1 0 0;
  border-radius: 16px;
  background: ${colors.white[100]};

  div {
    display: flex;
    flex: 1 0 0;
  }
`;

const CardsContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
`;

const CardsBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;

  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;

      h6 {
      align-self: stretch;
      color: ${colors.brightGray[600]};
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 160%;
      letter-spacing: 0.15px;
      margin-top: 32px;
    }

    p {
      align-self: stretch;
      color: ${colors.brightGray[600]};
      font-family: "Source Sans Pro";
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 175%;
      letter-spacing: 0.15px;
      margin-bottom: 16px;
    }
  }
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const CardsLink = styled.div`
  display: inline-flex !important;
  justify-content: center;
  align-items: center;
  gap: 8px;

  a {
    display: inline;
    color: ${colors.punch[500]} !important;
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 157%;
    letter-spacing: 0.1px;
    cursor: pointer;
    text-decoration: none !important;
  }

  svg {
    display: inline;
  }
`;

const SocialsDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  p {
    width: 891px;
    color: ${colors.brightGray[700]};
    font-family: "Source Sans Pro";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.15px;
  }

  div {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    gap: 12px;
    flex-wrap: wrap;

    svg {
      cursor: pointer;
    }
  }
`;

const DialogActions = styled(MuiDialogActions)`
  display: flex;
  padding: 8px 32px;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const Support = ({ open, onClose }) => {

  const handleRedirect = (url) => {
    window.open(url, '_blank');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogElements>
        <DialogTitle id="alert-dialog-title">
          Como podemos ajudar?
        </DialogTitle>
        <DialogContent>
          <DialogBody>
            <Text>
              <DialogContentText id="alert-dialog-description">
                Se precisar de suporte, tirar dúvidas sobre a plataforma ou aprimorar sua experiência, estamos aqui para ajudar. Escolha a melhor forma de contato e encontre as informações que precisa.
              </DialogContentText>
              <CardsDiv>
                <Cards>
                  <CardsContent>
                    <CardsBody>
                      <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
                        <path d="M6.70312 39C4.875 39 3.30078 38.5229 1.98047 37.5686C0.660156 36.6143 0 35.4332 0 34.0253V7.83755C0 6.64862 0.477344 5.58484 1.43203 4.64621C2.38672 3.70758 3.63594 3.11312 5.17969 2.86282L23.4609 0.0938628C24.9641 -0.156438 26.3047 0.0938628 27.4828 0.844765C28.6609 1.59567 29.25 2.56558 29.25 3.75451V26.1408C29.25 27.0481 28.8844 27.8538 28.1531 28.5578C27.4219 29.2617 26.4875 29.6919 25.35 29.8484L6.15469 32.8051C5.78906 32.8676 5.48438 33.0162 5.24063 33.2509C4.99688 33.4856 4.875 33.7437 4.875 34.0253C4.875 34.3694 5.05781 34.6588 5.42344 34.8935C5.78906 35.1282 6.21562 35.2455 6.70312 35.2455H34.125V7.08664C34.125 6.55475 34.3586 6.10891 34.8258 5.7491C35.293 5.38929 35.8719 5.20939 36.5625 5.20939C37.2531 5.20939 37.832 5.38929 38.2992 5.7491C38.7664 6.10891 39 6.55475 39 7.08664V35.2455C39 36.278 38.5227 37.1619 37.568 37.8971C36.6133 38.6324 35.4656 39 34.125 39H6.70312ZM12.1875 28.065L24.375 26.2347V3.80144L12.1875 5.63177V28.065ZM7.3125 28.8159V6.38267L6.39844 6.52347C5.95156 6.58604 5.58594 6.73466 5.30156 6.96931C5.01719 7.20397 4.875 7.49338 4.875 7.83755V29.2852C5.07812 29.2226 5.29141 29.1679 5.51484 29.1209C5.73828 29.074 5.95156 29.0349 6.15469 29.0036L7.3125 28.8159Z" fill="#464C5E"/>
                      </svg>
                      <div>
                        <Div>
                          <h6>Acesse o blog do RH</h6>
                          <p>Encontre artigos e as melhores dicas para facilitar a vida do RH</p>
                        </Div>
                        <CardsLink>
                          <a href="https://blog.walljobs.com.br/" target="_blank" rel="noopener noreferrer">
                            Acessar blog &nbsp;
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                              <path d="M6.72763 2.66302L1.06561 8.32505C0.948973 8.44168 0.80053 8.5 0.620278 8.5C0.440027 8.5 0.291584 8.44168 0.17495 8.32505C0.0583168 8.20842 0 8.05997 0 7.87972C0 7.69947 0.0583168 7.55103 0.17495 7.43439L5.83698 1.77237H1.00199C0.821736 1.77237 0.670643 1.7114 0.548708 1.58946C0.426773 1.46753 0.365805 1.31643 0.365805 1.13618C0.365805 0.955931 0.426773 0.804838 0.548708 0.682903C0.670643 0.560968 0.821736 0.5 1.00199 0.5H7.36382C7.54407 0.5 7.69516 0.560968 7.8171 0.682903C7.93903 0.804838 8 0.955931 8 1.13618V7.49801C8 7.67826 7.93903 7.82936 7.8171 7.95129C7.69516 8.07323 7.54407 8.13419 7.36382 8.13419C7.18357 8.13419 7.03247 8.07323 6.91054 7.95129C6.7886 7.82936 6.72763 7.67826 6.72763 7.49801V2.66302Z" fill="#FE3B35"/>
                            </svg>
                          </a>
                        </CardsLink>
                      </div>
                    </CardsBody>
                  </CardsContent>
                </Cards>
                <Cards>
                  <CardsContent>
                    <CardsBody>
                      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="45" viewBox="0 0 46 45" fill="none">
                        <path d="M8.16666 37.5C7.13541 37.5 6.25259 37.1328 5.51822 36.3984C4.78384 35.6641 4.41666 34.7812 4.41666 33.75V11.25C4.41666 10.2188 4.78384 9.33594 5.51822 8.60156C6.25259 7.86719 7.13541 7.5 8.16666 7.5H38.1667C39.1979 7.5 40.0807 7.86719 40.8151 8.60156C41.5495 9.33594 41.9167 10.2188 41.9167 11.25V33.75C41.9167 34.7812 41.5495 35.6641 40.8151 36.3984C40.0807 37.1328 39.1979 37.5 38.1667 37.5H8.16666ZM38.1667 15L24.151 23.7656C23.9948 23.8594 23.8307 23.9297 23.6588 23.9766C23.487 24.0234 23.3229 24.0469 23.1667 24.0469C23.0104 24.0469 22.8463 24.0234 22.6745 23.9766C22.5026 23.9297 22.3385 23.8594 22.1823 23.7656L8.16666 15V33.75H38.1667V15ZM23.1667 20.625L38.1667 11.25H8.16666L23.1667 20.625ZM8.16666 15.4688V12.7031V12.75V12.7266V15.4688Z" fill="#464C5E"/>
                      </svg>
                      <div>
                        <Div>
                          <h6>Mande um e-mail</h6>
                          <p>Para tirar dúvidas ou resolver qualquer problema envie um e-mail para <span>suporte@walljobs.com.br</span></p>
                        </Div>
                        <CardsLink>
                          <a href="mailto:suporte@walljobs.com.br">
                            Enviar-e-mail &nbsp;
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                              <path d="M6.72763 2.66302L1.06561 8.32505C0.948973 8.44168 0.80053 8.5 0.620278 8.5C0.440027 8.5 0.291584 8.44168 0.17495 8.32505C0.0583168 8.20842 0 8.05997 0 7.87972C0 7.69947 0.0583168 7.55103 0.17495 7.43439L5.83698 1.77237H1.00199C0.821736 1.77237 0.670643 1.7114 0.548708 1.58946C0.426773 1.46753 0.365805 1.31643 0.365805 1.13618C0.365805 0.955931 0.426773 0.804838 0.548708 0.682903C0.670643 0.560968 0.821736 0.5 1.00199 0.5H7.36382C7.54407 0.5 7.69516 0.560968 7.8171 0.682903C7.93903 0.804838 8 0.955931 8 1.13618V7.49801C8 7.67826 7.93903 7.82936 7.8171 7.95129C7.69516 8.07323 7.54407 8.13419 7.36382 8.13419C7.18357 8.13419 7.03247 8.07323 6.91054 7.95129C6.7886 7.82936 6.72763 7.67826 6.72763 7.49801V2.66302Z" fill="#FE3B35"/>
                            </svg>
                          </a>
                        </CardsLink>
                      </div>
                    </CardsBody>
                  </CardsContent>
                </Cards>
                <Cards>
                  <CardsContent>
                    <CardsBody>
                      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="39" viewBox="0 0 40 39" fill="none">
                        <path d="M37.0584 39C32.5445 39 28.0848 38.016 23.6792 36.0479C19.2737 34.0799 15.2653 31.2903 11.6542 27.6792C8.0431 24.0681 5.25351 20.0597 3.28546 15.6542C1.3174 11.2486 0.333374 6.78889 0.333374 2.275C0.333374 1.625 0.550041 1.08333 0.983374 0.65C1.41671 0.216667 1.95837 0 2.60837 0H11.3834C11.8889 0 12.3403 0.171528 12.7375 0.514583C13.1348 0.857639 13.3695 1.26389 13.4417 1.73333L14.85 9.31667C14.9223 9.89445 14.9042 10.3819 14.7959 10.7792C14.6875 11.1764 14.4889 11.5194 14.2 11.8083L8.94587 17.1167C9.6681 18.4528 10.5257 19.7438 11.5188 20.9896C12.5118 22.2354 13.6042 23.4361 14.7959 24.5917C15.9153 25.7111 17.0889 26.7493 18.3167 27.7063C19.5445 28.6632 20.8445 29.5389 22.2167 30.3333L27.3084 25.2417C27.6334 24.9167 28.0577 24.6729 28.5813 24.5104C29.1049 24.3479 29.6195 24.3028 30.125 24.375L37.6 25.8917C38.1056 26.0361 38.5209 26.2979 38.8459 26.6771C39.1709 27.0563 39.3334 27.4806 39.3334 27.95V36.725C39.3334 37.375 39.1167 37.9167 38.6834 38.35C38.25 38.7833 37.7084 39 37.0584 39Z" fill="#464C5E"/>
                      </svg>
                      <div>
                        <Div>
                          <h6>Fale conosco</h6>
                          <p>Ligue para nosso telefone (11) 4780-5870 e fale com o nosso suporte.</p>
                        </Div>
                        <CardsLink>
                          <a href="tel:1147805870">
                            Ligar agora &nbsp;
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                <path d="M6.72763 2.66302L1.06561 8.32505C0.948973 8.44168 0.80053 8.5 0.620278 8.5C0.440027 8.5 0.291584 8.44168 0.17495 8.32505C0.0583168 8.20842 0 8.05997 0 7.87972C0 7.69947 0.0583168 7.55103 0.17495 7.43439L5.83698 1.77237H1.00199C0.821736 1.77237 0.670643 1.7114 0.548708 1.58946C0.426773 1.46753 0.365805 1.31643 0.365805 1.13618C0.365805 0.955931 0.426773 0.804838 0.548708 0.682903C0.670643 0.560968 0.821736 0.5 1.00199 0.5H7.36382C7.54407 0.5 7.69516 0.560968 7.8171 0.682903C7.93903 0.804838 8 0.955931 8 1.13618V7.49801C8 7.67826 7.93903 7.82936 7.8171 7.95129C7.69516 8.07323 7.54407 8.13419 7.36382 8.13419C7.18357 8.13419 7.03247 8.07323 6.91054 7.95129C6.7886 7.82936 6.72763 7.67826 6.72763 7.49801V2.66302Z" fill="#FE3B35"/>
                            </svg>
                          </a>
                        </CardsLink>
                      </div>
                    </CardsBody>
                  </CardsContent>
                </Cards>
              </CardsDiv>
            </Text>
            <SocialsDiv>
              <p>Nos siga nas redes sociais</p>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none" onClick={() => handleRedirect('https://br.linkedin.com/company/walljobs')}>
                  <path d="M41.1667 6.5C42.3159 6.5 43.4181 6.95655 44.2308 7.7692C45.0435 8.58186 45.5 9.68406 45.5 10.8333V41.1667C45.5 42.3159 45.0435 43.4181 44.2308 44.2308C43.4181 45.0435 42.3159 45.5 41.1667 45.5H10.8333C9.68406 45.5 8.58186 45.0435 7.7692 44.2308C6.95655 43.4181 6.5 42.3159 6.5 41.1667V10.8333C6.5 9.68406 6.95655 8.58186 7.7692 7.7692C8.58186 6.95655 9.68406 6.5 10.8333 6.5H41.1667ZM40.0833 40.0833V28.6C40.0833 26.7267 39.3392 24.9301 38.0145 23.6055C36.6899 22.2808 34.8933 21.5367 33.02 21.5367C31.1783 21.5367 29.0333 22.6633 27.9933 24.3533V21.9483H21.9483V40.0833H27.9933V29.4017C27.9933 27.7333 29.3367 26.3683 31.005 26.3683C31.8095 26.3683 32.581 26.6879 33.1499 27.2568C33.7188 27.8256 34.0383 28.5972 34.0383 29.4017V40.0833H40.0833ZM14.9067 18.5467C15.8721 18.5467 16.7979 18.1632 17.4805 17.4805C18.1632 16.7979 18.5467 15.8721 18.5467 14.9067C18.5467 12.8917 16.9217 11.245 14.9067 11.245C13.9355 11.245 13.0042 11.6308 12.3175 12.3175C11.6308 13.0042 11.245 13.9355 11.245 14.9067C11.245 16.9217 12.8917 18.5467 14.9067 18.5467ZM17.9183 40.0833V21.9483H11.9167V40.0833H17.9183Z" fill="#464C5E"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none" onClick={() => handleRedirect('https://www.instagram.com/wall.jobs/')}>
                  <path d="M16.9001 4.33362H35.1001C42.0334 4.33362 47.6667 9.96695 47.6667 16.9003V35.1003C47.6667 38.4332 46.3428 41.6296 43.986 43.9863C41.6293 46.343 38.433 47.6669 35.1001 47.6669H16.9001C9.96674 47.6669 4.3334 42.0336 4.3334 35.1003V16.9003C4.3334 13.5674 5.65739 10.371 8.0141 8.01431C10.3708 5.6576 13.5672 4.33362 16.9001 4.33362ZM16.4667 8.66695C14.398 8.66695 12.4141 9.48873 10.9513 10.9515C9.48852 12.4143 8.66674 14.3983 8.66674 16.467V35.5336C8.66674 39.8453 12.1551 43.3336 16.4667 43.3336H35.5334C37.6021 43.3336 39.5861 42.5118 41.0488 41.049C42.5116 39.5863 43.3334 37.6023 43.3334 35.5336V16.467C43.3334 12.1553 39.8451 8.66695 35.5334 8.66695H16.4667ZM37.3751 11.917C38.0934 11.917 38.7822 12.2023 39.2901 12.7102C39.7981 13.2181 40.0834 13.907 40.0834 14.6253C40.0834 15.3436 39.7981 16.0325 39.2901 16.5404C38.7822 17.0483 38.0934 17.3336 37.3751 17.3336C36.6568 17.3336 35.9679 17.0483 35.46 16.5404C34.9521 16.0325 34.6667 15.3436 34.6667 14.6253C34.6667 13.907 34.9521 13.2181 35.46 12.7102C35.9679 12.2023 36.6568 11.917 37.3751 11.917ZM26.0001 15.167C28.8732 15.167 31.6287 16.3083 33.6604 18.34C35.692 20.3716 36.8334 23.1271 36.8334 26.0003C36.8334 28.8735 35.692 31.629 33.6604 33.6606C31.6287 35.6922 28.8732 36.8336 26.0001 36.8336C23.1269 36.8336 20.3714 35.6922 18.3397 33.6606C16.3081 31.629 15.1667 28.8735 15.1667 26.0003C15.1667 23.1271 16.3081 20.3716 18.3397 18.34C20.3714 16.3083 23.1269 15.167 26.0001 15.167ZM26.0001 19.5003C24.2762 19.5003 22.6229 20.1851 21.4039 21.4041C20.1849 22.6231 19.5001 24.2764 19.5001 26.0003C19.5001 27.7242 20.1849 29.3775 21.4039 30.5965C22.6229 31.8155 24.2762 32.5003 26.0001 32.5003C27.724 32.5003 29.3773 31.8155 30.5963 30.5965C31.8153 29.3775 32.5001 27.7242 32.5001 26.0003C32.5001 24.2764 31.8153 22.6231 30.5963 21.4041C29.3773 20.1851 27.724 19.5003 26.0001 19.5003Z" fill="#464C5E"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none" onClick={() => handleRedirect('https://www.tiktok.com/@walljobs')}>
                  <path d="M35.9666 12.61C34.4859 10.919 33.6697 8.7477 33.6699 6.5H26.9749V33.3667C26.9244 34.8209 26.3109 36.1987 25.2639 37.2092C24.217 38.2198 22.8184 38.7842 21.3633 38.7833C18.2866 38.7833 15.7299 36.27 15.7299 33.15C15.7299 29.4233 19.3266 26.6283 23.0316 27.7767V20.93C15.5566 19.9333 9.01326 25.74 9.01326 33.15C9.01326 40.365 14.9933 45.5 21.3416 45.5C28.1449 45.5 33.6699 39.975 33.6699 33.15V19.5217C36.3848 21.4713 39.6442 22.5174 42.9866 22.5117V15.8167C42.9866 15.8167 38.9133 16.0117 35.9666 12.61Z" fill="#464C5E"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none" onClick={() => handleRedirect('https://www.youtube.com/user/walljobs')}>
                  <path d="M21.6667 32.5L32.9117 26L21.6667 19.5V32.5ZM46.7133 15.535C46.995 16.5533 47.19 17.9183 47.32 19.6516C47.4717 21.385 47.5367 22.88 47.5367 24.18L47.6667 26C47.6667 30.745 47.32 34.2333 46.7133 36.465C46.1717 38.415 44.915 39.6716 42.965 40.2133C41.9467 40.495 40.0833 40.69 37.2233 40.82C34.4067 40.9716 31.8283 41.0366 29.445 41.0366L26 41.1666C16.9217 41.1666 11.2667 40.82 9.035 40.2133C7.085 39.6716 5.82833 38.415 5.28667 36.465C5.005 35.4466 4.81 34.0816 4.68 32.3483C4.52833 30.615 4.46333 29.12 4.46333 27.82L4.33333 26C4.33333 21.255 4.68 17.7666 5.28667 15.535C5.82833 13.585 7.085 12.3283 9.035 11.7866C10.0533 11.505 11.9167 11.31 14.7767 11.18C17.5933 11.0283 20.1717 10.9633 22.555 10.9633L26 10.8333C35.0783 10.8333 40.7333 11.18 42.965 11.7866C44.915 12.3283 46.1717 13.585 46.7133 15.535Z" fill="#464C5E"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none" onClick={() => handleRedirect('https://www.facebook.com/wjtrampos/?locale=pt_BR')}>
                  <path d="M26.0001 4.41962C14.0834 4.41962 4.3334 14.148 4.3334 26.1296C4.3334 36.963 12.2634 45.9546 22.6201 47.5796V32.413H17.1167V26.1296H22.6201V21.3413C22.6201 15.903 25.8484 12.913 30.8101 12.913C33.1717 12.913 35.6417 13.3246 35.6417 13.3246V18.6763H32.9117C30.2251 18.6763 29.3801 20.3446 29.3801 22.0563V26.1296H35.4034L34.4284 32.413H29.3801V47.5796C34.4857 46.7733 39.1348 44.1682 42.4882 40.2347C45.8416 36.3013 47.6783 31.2985 47.6667 26.1296C47.6667 14.148 37.9167 4.41962 26.0001 4.41962Z" fill="#464C5E"/>
                </svg>
              </div>
            </SocialsDiv>
          </DialogBody>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={onClose}>Fechar</Button>
        </DialogActions>
      </DialogElements>
    </Dialog>
  );
};

export default Support;
